import React from 'react'

export default function Retail() {
  return (
    <div>Retail</div>
  )
}
